import { SortingOrder } from 'models/types';

const toggleSortingOrder = (sortByValue: number) => {
  return sortByValue == SortingOrder.ASCENDING ? SortingOrder.DESCENDING : SortingOrder.ASCENDING;
};

export { toggleSortingOrder };
